import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ShareTwo = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C11.1716 3 10.5 3.67157 10.5 4.5C10.5 5.32843 11.1716 6 12 6C12.8284 6 13.5 5.32843 13.5 4.5C13.5 3.67157 12.8284 3 12 3ZM9.5 4.5C9.5 3.11929 10.6193 2 12 2C13.3807 2 14.5 3.11929 14.5 4.5C14.5 5.88071 13.3807 7 12 7C10.6193 7 9.5 5.88071 9.5 4.5ZM12 9.00006C10.7575 9.00006 9.60932 9.79987 8.90794 10.7892C8.74823 11.0145 8.43614 11.0676 8.21087 10.9079C7.98559 10.7482 7.93244 10.4361 8.09214 10.2109C8.9144 9.05103 10.333 8.00006 12 8.00006C13.6671 8.00006 15.0857 9.05103 15.9079 10.2109C16.0676 10.4361 16.0145 10.7482 15.7892 10.9079C15.5639 11.0676 15.2519 11.0145 15.0921 10.7892C14.3908 9.79987 13.2426 9.00006 12 9.00006ZM4 6.49997C3.17157 6.49997 2.5 7.17154 2.5 7.99997C2.5 8.8284 3.17157 9.49997 4 9.49997C4.82843 9.49997 5.5 8.8284 5.5 7.99997C5.5 7.17154 4.82843 6.49997 4 6.49997ZM1.5 7.99997C1.5 6.61926 2.61929 5.49997 4 5.49997C5.38071 5.49997 6.5 6.61926 6.5 7.99997C6.5 9.38068 5.38071 10.5 4 10.5C2.61929 10.5 1.5 9.38068 1.5 7.99997ZM4.00004 12.5C2.75745 12.5 1.60932 13.2998 0.907936 14.2892C0.748229 14.5144 0.436141 14.5676 0.210867 14.4079C-0.0144077 14.2482 -0.0675612 13.9361 0.092145 13.7108C0.914397 12.551 2.33301 11.5 4.00004 11.5C5.66707 11.5 7.08568 12.551 7.90794 13.7108C8.06764 13.9361 8.01449 14.2482 7.78921 14.4079C7.56394 14.5676 7.25185 14.5144 7.09215 14.2892C6.39076 13.2998 5.24263 12.5 4.00004 12.5Z"
      />
    </svg>
  )
})

export default ShareTwo
